import React, { ReactElement } from "react";
import StreamInfo from "../StreamInfo/StreamInfo";
import { Button } from "@screencloud/screencloud-ui-components";
import { Stream } from "../../types";
import "./StreamSetup.scss";

const INFO = {
  HELP: "Help Setting Up Your Live Stream",
  HELP_DESCRIPTION:
    "Follow the link below for help setting up your broadcast for the first time.",
  HELP_BUTTON: "Live Video Setup",
};
interface StreamSetupProps {
  stream: Stream | null;
}

const StreamSetup = (
  props: StreamSetupProps
): ReactElement<StreamSetupProps> => {
  return (
    <>
      <StreamInfo stream={props.stream} />
      <br />
      <div className="stream-info-header">{INFO.HELP}</div>
      <div className="stream-info-copy">{INFO.HELP_DESCRIPTION}</div>
      <Button
        outline="true"
        onClick={() =>
          window.open(process.env.REACT_APP_LIVE_STREAMS_HELP_LINK, "_blank")
        }
      >
        {INFO.HELP_BUTTON}
      </Button>
    </>
  );
};

export default StreamSetup;
